// extracted by mini-css-extract-plugin
export default {"sliderOptions":"ZmTO8FouVe1D36SoVvCQ"};